/*
 *  -----------------------------------------------------------------------
 *    <copyright file="admin-study-settings.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React from 'react';
import AdminStudyDetails from 'views/components/admin/studies/admin-study-details';

const AdminStudySettings = () => <AdminStudyDetails />;

export default AdminStudySettings;
